import React from 'react';
import { Toggle } from 'ui';
import HelpLink from '~/components/Links/HelpLink';
import {
  isUsingShippingInsurance,
  toggleShippingInsurance,
} from '~/store/listFlow/slices/shipping';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowShippingInsurance: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const enabled = useAppSelector(isUsingShippingInsurance);

  return (
    <div className="mt-4">
      <label className="mb-1 flex items-center space-x-2">
        <Toggle
          onChange={v =>
            dispatch(toggleShippingInsurance({ useShippingInsurance: v }))
          }
          value={!!enabled}
        />
        <span className="font-semibold">Add shipping insurance</span>
      </label>

      <div className="text-sm italic">
        Adding shipping insurance will deduct 1% of the sale price of the item
        from your earnings.{' '}
        <HelpLink
          link="shippingInsurance"
          title="Click here to learn more about shipping insurance"
          className="text-blue-500 underline"
        >
          Learn more
        </HelpLink>
        .
      </div>
    </div>
  );
};

export default ListFlowShippingInsurance;
